import { IAction, ICharacteristicFunctionInput } from "./builder.dtos";

export interface IBluetoothCharacteristic {
  id: string;
  serviceId: string;
  functionName: string;
  characteristicType: EBluetoothCharacteristicType;
  actions: IAction[];
  inputs: ICharacteristicFunctionInput[];
}

export enum EBluetoothCharacteristicType {
  Read = 0,
  Write = 1,
  Notify = 2,
  Indicate = 3
}
